import Cal, { getCalApi } from "@calcom/embed-react";
import { Typography } from "@mui/material";
import { useEffect } from "react";
import { userStore } from "../../zustand";



function CalApp() {

    const { user } = userStore()

    useEffect(() => {
        (async function () {
            const cal = await getCalApi({ "namespace": "discussion" });
            cal("ui", { "theme": "light", "cssVarsPerTheme": { "light": { "cal-brand": "#000687" }, "dark": { "cal-brand": "#000687" } }, "hideEventTypeDetails": false, "layout": "month_view" });
        })();
    }, [])
    return <Cal
        config={{
            name: user && 'last_name' in user && user.last_name !== '' ? `${user?.first_name} ${user?.last_name}` : '',
            email: user ? user?.email : '',
            "layout": "month_view",
            "theme": "light"
        }}
        namespace="discussion"
        calLink="doshby/discussion"
        style={{ width: "100%", height: "100%", overflow: "scroll" }}
    />;
};


export default function CalSchedule() {
    return (
        <>
            <div className="calendar-container">
                <Typography variant="h4"
                    fontWeight={600}
                    sx={{
                        textAlign: 'center',
                        mt: '1rem',
                        mb: '2rem',
                    }} gutterBottom>
                    Schedule a meeting with us </Typography>
                <CalApp />
            </div>
        </>
    );
}